module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event3/younite-event-ja-25a6af6b0ac6dfa17290d9a269779b57.png";